/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Too_Many_RequestsInputs */

const en_us2_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've sent a lot of photo estimates in the last hour. Try again later. The ones you sent are safe.`)
};

const pt_br2_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você mandou muitas estimativas por foto na última hora. Tente mais tarde. As que você mandou estão salvas.`)
};

const es_419_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviaste muchas estimaciones por foto en la última hora. Intenta más tarde. Las que enviaste están guardadas.`)
};

const pt_pt2_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviaste muitas estimativas por fotografia na última hora. Tenta mais tarde. As que enviaste estão guardadas.`)
};

const fr_fr2_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as envoyé beaucoup d'estimations par photo dans la dernière heure. Réessaie plus tard. Celles que tu as envoyées sont enregistrées.`)
};

const de_de2_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast in der letzten Stunde viele Foto-Schätzungen gesendet. Versuch es später noch mal. Die gesendeten sind sicher.`)
};

const it_it2_body_assessment_too_many_requests = /** @type {(inputs: Body_Assessment_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai inviato molte stime da foto nell'ultima ora. Riprova più tardi. Quelle che hai inviato sono al sicuro.`)
};

/**
* | output |
* | --- |
* | "You've sent a lot of photo estimates in the last hour. Try again later. The ones you sent are safe." |
*
* @param {Body_Assessment_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_too_many_requests = /** @type {((inputs?: Body_Assessment_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_too_many_requests(inputs)
	if (locale === "es-419") return es_419_body_assessment_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_too_many_requests(inputs)
	return en_us2_body_assessment_too_many_requests(inputs)
});
export { body_assessment_too_many_requests as "body_assessment.too_many_requests" }